import React from "react";
import Extended from "./Extended";
import Footer from "./Footer";
import Header from './Header';
import Home from "./Home";
import './styles.css';

const App = () => {
    return (
        <div className='container-fluid content'>
            <Header />
            <Home />
            <Extended />
            <Footer />
        </div>
    );
};

export default App;